// <li class="copy--large line-height--copy"><a href="#">Link 1</a></li>
// elementoDestino.appendChild(elementoAnexado);

let initElScrollId = '';

const checkScroll = () => {
    document.querySelectorAll('.lagarh-question').forEach((element, idx) => {
        // const elementRect = element.getBoundingClientRect();
        // console.log(element, elementRect)
        const eleTop = element.getBoundingClientRect().top;
        if(eleTop > 0 && eleTop < 120) {
            const currendId = element.getAttribute('id');
            activeClass(document.querySelector(`a[href="#${currendId}"]`));
        }
        // if ( elementRect.top <= window.innerHeight && elementRect.bottom >= 0) {
        //     const currendId = element.getAttribute('id');
        //     if(initElScrollId != currendId){
        //         initElScrollId = currendId;
        //         activeClass(document.querySelector(`a[href="#${currendId}"]`));
        //     }
        // }
    })
}

window.addEventListener('scroll', checkScroll);

const activeClass = (link) => {
    const menuLinks = document.querySelectorAll('.faq-menu-links');
    menuLinks.forEach((menu, idx) => {
        if (menu.classList.contains('active')){
            menu.classList.remove('active');
        }
    })
    link.classList.add('active');
    //respostas
    document.querySelectorAll('.lagarh-question').forEach((question, idx) => {
        if (question.classList.contains('active')){
            question.classList.remove('active');
        }
    });
    document.querySelector(link.getAttribute('href')).classList.add('active');
}

const faqLink = (e) => {
    e.preventDefault();
    const currentEl = e.target;
    const currentId = currentEl.getAttribute('href');
    const faqQuestion = document.querySelector(currentId);
    faqQuestion.scrollIntoView({ behavior: "smooth" });
    
    
    // activeClass(currentEl);    
}

document.addEventListener('DOMContentLoaded', function() {
    
    const lagarFaqs = document.querySelectorAll('.lagarh-question');
    const contentFaqs = document.querySelector('.lagarh-faq-content');
    const contentMenu = document.querySelector('.list-menu-faq');

    if(lagarFaqs.length > 0){
        lagarFaqs.forEach((faq, idx) => {
            //insere faq
            contentFaqs.appendChild(faq);
            faq.classList.remove('faq-hide-content');

            //pega os titulos para o menu do FAQ
            const faqTitle = faq.querySelector('.question-group-title').textContent;
            const faqId = faq.getAttribute('id');
            const menuItem = document.createElement('li');
            menuItem.classList.add('copy--large', 'line-height--copy');
            const linkClass = idx === 0 ? 'faq-menu-links active' : 'faq-menu-links';
            menuItem.innerHTML = `<a href="#${faqId}" class="${linkClass}" onclick="faqLink(event)">${faqTitle}</a>`;
            contentMenu.appendChild(menuItem);
        })
    }

    document.querySelector('.lagarh-question:first-of-type').classList.add('active');
});